<div class="product--content" [attr.data-test]="'searched--product-' + product()?.code + '-content'">
  @if (product().images) {
    <cx-media
      [attr.data-test]="'searched--product-' + product()?.code + '-media'"
      [container]="product().images?.PRIMARY"
      [alt]="product().name"
      loading="lazy"
    />
  }
  <div class="product--name" [attr.data-test]="'searched--product-' + product()?.code + '-name-container'">
    <div
      class="h-200" data-test="searched-product--name"
      [attr.data-test]="'searched--product-' + product()?.code + '-name'"
    >{{ product().name }}
    </div>
    <div
      class="body-medium"
      [attr.data-test]="'searched--product-' + product()?.code + '-code'"
    >
      {{ 'dpProductSummary.orderingNumber' | cxTranslate }}:
      <span>{{ product().code }}</span>
    </div>
  </div>
  <dp-stock-info
    [attr.data-test]="'searched--product-' + product()?.code + '-stock-info'"
    class="product--stock"
    [lifecycleStatus]="product().lifecycleStatus" [type]="product()?.stockInfo?.stockLevelStatus"
    [replenishmentDate]="product()?.stockInfo?.replenishmentDate"
    [productCode]="product()?.code"
    [replacementProductCode]="product()?.replacements?.[0]"
    [isDefaultDC]="product()?.hasStockInDefaultDc"
  />
</div>
@if (product().description) {
  <div
    class="product--description body-medium text-overflow"
    [attr.data-test]="'searched--product-' + product()?.code + '-description'"
  >{{ product().description }}
  </div>
}
